module.exports = __webpack_public_path__ + "static/media/tasting-thumb.a0d032e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/tasting-thumb.jpg
// module id = 589
// module chunks = 0